import { get } from 'lodash';
import React from 'react';
import { ANTRAG_TYP, ART_DES_ANTRAGS, PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import { TreeNodeType } from '../../../../../../lib/types/types';
import { enumT } from '../../../../../../utils/helper';

// import schemas
import { FOERDERPROGRAMM_ALLGEMINE_HINWEISE_ANTRAG_PATHS } from 'src/lib/constants/componentsPath';
import Schema from '../../../../../../lib/paths/antrag_FULL_Paths.json';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import AllgemeinDateienGlobal from './content/AllgemeinDateienGlobal';
import AllgemeinHinweisGlobal from './content/AllgemeinHinweisGlobal';
const P = Schema.attributes;

export const TreeStructureAllgemeinHinweisGlobal = (application: any) => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Allgemeine Hinweise',
			content: (
				<ApplicationHeading
					title={`Allgemeine Hinweise zur Förderung: ${enumT(get(application, P.Foerderprogramm.schema.attributes.Allgemein_Titel.path, ''))}`}
					description={PLATZHALTER_TEXT}
				/>
			),
			children: TreeStructureAllgemeinHinweisGlobalChildren(application),
		},
	];

	return treeNodes;
};

const TreeStructureAllgemeinHinweisGlobalChildren = (application: any): TreeNodeType[] => {
	const antragsTyp = get(application, P.Allgemein_Typ.path, '');
	const foerderProgram = get(application, P.Foerderprogramm.path, {});
	const artDesAntrags = get(application, P.Allgemein_Art_Des_Antrags.path, '');
	const isFormantrag = artDesAntrags === ART_DES_ANTRAGS.Formantrag;
	const paths =
		antragsTyp === ANTRAG_TYP.Skizze ? FOERDERPROGRAMM_ALLGEMINE_HINWEISE_ANTRAG_PATHS.Skizze
		: isFormantrag ? FOERDERPROGRAMM_ALLGEMINE_HINWEISE_ANTRAG_PATHS.Formantrag
		: FOERDERPROGRAMM_ALLGEMINE_HINWEISE_ANTRAG_PATHS.Antrag;

	const hinweiseBlock_ARR = get(foerderProgram, paths.HinweisBlock, []);

	const hinweisNodes: TreeNodeType[] = hinweiseBlock_ARR.map((ele: any) => {
		return {
			label: get(ele, paths.Titel, ''),
			content: <AllgemeinHinweisGlobal eachHinweis={ele} hinweisPath={paths} />,
		};
	});

	const dateienNodes: TreeNodeType = {
		label: 'Downloads',
		content: <AllgemeinDateienGlobal />,
	};
	return [...hinweisNodes, dateienNodes];
};
